/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconIntegrations = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <path
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
        d="M19.5 15.75l3.311-3.311a1.5 1.5 0 0 0 0-2.121L20.7 8.212c-.804 1.909-3.003 2.804-4.912 1.999a3.749 3.749 0 0 1 0-6.911l-2.106-2.111a1.5 1.5 0 0 0-2.121 0L8.25 4.5A3.75 3.75 0 1 0 4.5 8.25l-3.311 3.311a1.5 1.5 0 0 0 0 2.121L3.3 15.788c.804-1.909 3.003-2.804 4.912-1.999a3.749 3.749 0 0 1 0 6.911l2.106 2.107a1.5 1.5 0 0 0 2.121 0L15.75 19.5a3.75 3.75 0 1 0 3.75-3.75z"
      />
    </svg>
  ),
);
